import * as actions from '../constants'

const inititalState = {
  loadingAbout: true,
  loadingAboutError: null,
  shanghai: null,
  foundIn: null,
  ha: null
}

export default (state = inititalState, action) => {
  switch (action.type) {
    case actions.LOAD_HA_REQUEST:
      return {
        ...state,
        ha: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_HA_SUCCESS:
      return {
        ...state,
        ha: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_HA_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }
    case actions.LOAD_SHANGHAI_REQUEST:
      return {
        ...state,
        shanghai: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_SHANGHAI_SUCCESS:
      return {
        ...state,
        shanghai: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_SHANGHAI_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }

    case actions.LOAD_FOUNDIN_REQUEST:
      return {
        ...state,
        foundIn: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_FOUNDIN_SUCCESS:
      return {
        ...state,
        foundIn: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_FOUNDIN_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }

    case actions.LOAD_FOUNDERS_REQUEST:
      return {
        ...state,
        founders: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_FOUNDERS_SUCCESS:
      return {
        ...state,
        founders: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_FOUNDERS_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }

    case actions.LOAD_PARTNERS_REQUEST:
      return {
        ...state,
        partners: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_PARTNERS_SUCCESS:
      return {
        ...state,
        partners: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_PARTNERS_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }

    case actions.LOAD_CONTRIBUTORS_REQUEST:
      return {
        ...state,
        contributors: null,
        loadingAbout: true,
        loadingAboutError: null
      }
    case actions.LOAD_CONTRIBUTORS_SUCCESS:
      return {
        ...state,
        contributors: action.payload[0],
        loadingAbout: false,
        loadingAboutError: null
      }
    case actions.LOAD_CONTRIBUTORS_FAILURE:
      return {
        ...state,
        loadingAbout: false,
        loadingAboutError: action.payload
      }

    default:
      return state
  }
}
